import React from 'react';

import useTranslate from 'lib/languages/useTranslate';
import { useNavigate } from 'react-router-dom';

interface SectionTitleProps {
    tag?: keyof JSX.IntrinsicElements;
    title?: React.ReactNode;
    secondary?: boolean;
    backRoute?: string;
    backState?: Record<string, unknown> | null;
    additionalText?: React.ReactNode;
    goBack?: boolean;
}

const SectionTitle = ({
    tag,
    title,
    secondary = false,
    backRoute,
    backState = {},
    additionalText,
    goBack,
}: SectionTitleProps) => {
    const navigate = useNavigate();
    const TagName = tag ?? (secondary ? 'h3' : 'h1');
    const translate = useTranslate('generic');

    const handleBackClick = () => {
        if (goBack) {
            navigate(-1);
        } else if (!backState) {
            navigate(backRoute as string);
        } else {
            navigate(backRoute as string, {
                state: backState,
            });
        }
    };

    if (secondary) return <TagName className="section-title">{title}</TagName>;

    return (
        <TagName className="section-title">
            {title}
            {(backRoute || goBack) && (
                // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
                <span onClick={handleBackClick}> {/* NOSONAR: styled as inline text, not a button */}
                    <i className="fa fa-arrow-left"></i>
                    {translate('back')}
                </span>
            )}
            {additionalText && <p className="info">{additionalText}</p>}
        </TagName>
    );
};

export default SectionTitle;
